import startCase from 'lodash/startCase';

export default class StringTools {
    public static toSentenceCase(str: string)
    {
        return startCase(str);
    }
}